import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { forEach } from '@beef/utils';
import { NodeSection } from "../props/node/constants";
import { traverse } from "../traverse";
export var UnknownNodeWhileCloning = /*#__PURE__*/function (_Error) {
  _inherits(UnknownNodeWhileCloning, _Error);
  var _super = _createSuper(UnknownNodeWhileCloning);
  function UnknownNodeWhileCloning() {
    _classCallCheck(this, UnknownNodeWhileCloning);
    return _super.apply(this, arguments);
  }
  return _createClass(UnknownNodeWhileCloning);
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var CloneCopiedNodesVisitor = {
  NodeTree: function NodeTree(path, state) {
    var nodes = state.opts.nodes;
    state.mappedNodeIds = {};

    // Reconnect nodes
    this.executeChange(function () {
      forEach(nodes, function (node, oldNodeId) {
        state.mappedNodeIds[oldNodeId] = path.node.attachNode(node);
      });
    });

    // traverse added nodes
    forEach(state.mappedNodeIds, function (nodeId) {
      traverse(path.node.nodes[nodeId], CloneCopiedNodesVisitor, state);
    });
    this.skip();
  },
  Node: {
    enterChild: function enterChild(path) {
      if (path.params.section !== NodeSection.CHILDREN) this.skip();
    }
  },
  ListOfIdentifiers: function ListOfIdentifiers(path, state) {
    this.executeChange(function () {
      path.node.value = path.node.value.map(function (oldNodeId) {
        if (!state.mappedNodeIds[oldNodeId]) throw new UnknownNodeWhileCloning("\u041D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u044B\u0439 \u0443\u0437\u0435\u043B ".concat(oldNodeId, " \u043F\u0440\u0438 \u043A\u043B\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0438 \u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u044B"));
        return state.mappedNodeIds[oldNodeId];
      });
    });
  }
};